import React, {Fragment} from 'react';

import { 
  BulmaHero 
} from '../../components/HelperComponents/HelperComponents';

import {
  AccountH1,
  AccountH2,
  PrimaryButton
} from '../../components/HelperComponents/StyledComponents';


import BackgroundImage from '../../images/background.png';

const HeroBody = () => (
  <Fragment>
    <section className="container">
      <section className="columns is-centered">
        <section className="column is-6 has-text-white">
          <AccountH1>Account Succesfully created!</AccountH1>
          <AccountH2>Start exploring!</AccountH2>
          <PrimaryButton className="button is-rounded">Start Now</PrimaryButton>
        </section>
      </section>
    </section>
  </Fragment>
);

const AccountCreated = () => (
  <BulmaHero heroSize="is-fullheight" body={<HeroBody />} image={BackgroundImage}></BulmaHero>
);

export { AccountCreated };



// WEBPACK FOOTER //
// ./src/routes/AccountCreated/AccountCreated.js